var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlace24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99984 0.166748C2.74234 0.166748 0.916504 1.99258 0.916504 4.25008C0.916504 7.31258 4.99984 11.8334 4.99984 11.8334C4.99984 11.8334 9.08317 7.31258 9.08317 4.25008C9.08317 1.99258 7.25734 0.166748 4.99984 0.166748ZM2.08317 4.25008C2.08317 2.64008 3.38984 1.33341 4.99984 1.33341C6.60984 1.33341 7.9165 2.64008 7.9165 4.25008C7.9165 5.93008 6.2365 8.44425 4.99984 10.0134C3.7865 8.45592 2.08317 5.91258 2.08317 4.25008ZM3.5415 4.25008C3.5415 3.44467 4.19442 2.79175 4.99984 2.79175C5.52085 2.79175 6.00228 3.0697 6.26279 3.52091C6.5233 3.97212 6.5233 4.52804 6.26279 4.97925C6.00228 5.43046 5.52085 5.70842 4.99984 5.70842C4.19442 5.70842 3.5415 5.0555 3.5415 4.25008Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace24Px);
export default __webpack_public_path__ + "static/media/place_24px.24cdeec9e34ffc86e2d4b8021a827041.svg";
export { ForwardRef as ReactComponent };